import { createLabel } from "../../helpers";

export const players = [
  {
    name: "A.Egbewole",
    position: "+1",
    code: "CHI"
  },
  {
    name: "Akin Egbewole",
    position: "+1",
    code: "CHI"
  },
  {
    name: "Akin Egbewole",
    position: "+1",
    code: "CHI"
  },
  {
    name: "Akin Egbewole",
    position: "+1",
    code: "CHI"
  },
  {
    name: "Akin Egbewole",
    position: "+1",
    code: "CHI"
  }
];

export const filters = [
  {
    subFilter: [
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Singles",
        valueCode: "S"
      },
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Doubles",
        valueCode: "D"
      }
    ],
    filterName: "Player Type",
    dataName: "playerTypeCode",
    valueDesc: "Men",
    valueCode: "M"
  },
  {
    subFilter: [
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Singles",
        valueCode: "S"
      },
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Doubles",
        valueCode: "D"
      }
    ],
    filterName: "Player Type",
    dataName: "playerTypeCode",
    valueDesc: "Women",
    valueCode: "W"
  },
  {
    subFilter: [
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Singles",
        valueCode: "S"
      },
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Doubles",
        valueCode: "D"
      }
    ],
    filterName: "Player Type",
    dataName: "playerTypeCode",
    valueDesc: "Quad",
    valueCode: "Q"
  },
  {
    subFilter: [
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Singles",
        valueCode: "S"
      }
    ],
    filterName: "Player Type",
    dataName: "playerTypeCode",
    valueDesc: "Boys",
    valueCode: "B"
  },
  {
    subFilter: [
      {
        subFilter: null,
        filterName: "Match Type",
        dataName: "matchTypeCode",
        valueDesc: "Singles",
        valueCode: "S"
      }
    ],
    filterName: "Player Type",
    dataName: "playerTypeCode",
    valueDesc: "Girls",
    valueCode: "G"
  }
];

export const juniorFilters = [
  {
    subFilter: [
      {
        subFilter: null,
        filterName: "Race Type",
        dataName: "juniorRankingType",
        valueDesc: "ITF Junior Rankings",
        valueCode: "itf"
      },
      {
        subFilter: null,
        filterName: "Race Type",
        dataName: "juniorRankingType",
        valueDesc: "Juniors Road to Chengdu",
        valueCode: "chengu"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2018",
            valueCode: "2018"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2017",
            valueCode: "2017"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2016",
            valueCode: "2016"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2015",
            valueCode: "2015"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2014",
            valueCode: "2014"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2013",
            valueCode: "2013"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2012",
            valueCode: "2012"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2011",
            valueCode: "2011"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2010",
            valueCode: "2010"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2009",
            valueCode: "2009"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2008",
            valueCode: "2008"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2007",
            valueCode: "2007"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2006",
            valueCode: "2006"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2005",
            valueCode: "2005"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2004",
            valueCode: "2004"
          }
        ],
        filterName: "Race Type",
        dataName: "juniorRankingType",
        valueDesc: "Year End Rankings",
        valueCode: "year"
      }
    ],
    filterName: "Player Type",
    dataName: "playerTypeCode",
    valueDesc: "Boys",
    valueCode: "B"
  },
  {
    subFilter: [
      {
        subFilter: null,
        filterName: "Race Type",
        dataName: "juniorRankingType",
        valueDesc: "ITF Junior Rankings",
        valueCode: "itf"
      },
      {
        subFilter: null,
        filterName: "Race Type",
        dataName: "juniorRankingType",
        valueDesc: "Juniors Road to Chengdu",
        valueCode: "chengu"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2018",
            valueCode: "2018"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2017",
            valueCode: "2017"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2016",
            valueCode: "2016"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2015",
            valueCode: "2015"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2014",
            valueCode: "2014"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2013",
            valueCode: "2013"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2012",
            valueCode: "2012"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2011",
            valueCode: "2011"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2010",
            valueCode: "2010"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2009",
            valueCode: "2009"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2008",
            valueCode: "2008"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2007",
            valueCode: "2007"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2006",
            valueCode: "2006"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2005",
            valueCode: "2005"
          },
          {
            subFilter: null,
            filterName: "Year",
            dataName: "juniorEndYear",
            valueDesc: "2004",
            valueCode: "2004"
          }
        ],
        filterName: "Race Type",
        dataName: "juniorRankingType",
        valueDesc: "Year End Rankings",
        valueCode: "year"
      }
    ],
    filterName: "Player Type",
    dataName: "playerTypeCode",
    valueDesc: "Girls",
    valueCode: "G"
  }
];

export const tourOptions = createLabel([
  {
    name: "Men’s World Tennis Tour",
    url: "/en/whats-on/mens-calendar/",
    code: "MT"
  },
  {
    name: "Women’s World Tennis Tour",
    url: "/en/whats-on/womens-calendar/",
    code: "WT"
  },
  {
    name: "Juniors World Tennis Tour",
    url: "/en/whats-on/junior-calendar/",
    code: "JT"
  },
  {
    name: "Masters Tour",
    url: "/en/whats-on/seniors-tennis-calendar/",
    code: "VT"
  },
  {
    name: "Beach Tennis World Tour",
    url: "/en/whats-on/beach-calendar/",
    code: "BT"
  },
  {
    name: "UNIQLO Wheelchair Tennis Tour",
    url: "/en/whats-on/uniqlo-wheelchair-tennis-calendar/",
    code: "WCT"
  },
  {
    name: "Grand Slams",
    url: "",
    code: "SL"
  }
]);

export const Result = {
  Result: {
    headToHeadBaseUrl: "#/",
    items: [
      {
        playerId: 800319078,
        playerFamilyName: "STEUR",
        playerGivenName: "Julyette Maria Josephine",
        playerNationalityCode: "GER",
        playerNationality: "Germany",
        profileLink:
          "/en/players/biography/800319078/GER/Julyette-Maria-Josephine-STEUR/",
        birthYear: 1995,
        rankMovement: 0,
        rank: 7,
        rankEqualFlag: null,
        tournamentsPlayed: 15,
        points: "680.00"
      },
      {
        playerId: 800311972,
        playerFamilyName: "HERING",
        playerGivenName: "Katharina",
        playerNationalityCode: "GER",
        playerNationality: "Germany",
        profileLink: "/en/players/biography/800311972/GER/Katharina-HERING/",
        birthYear: 1995,
        rankMovement: 0,
        rank: 34,
        rankEqualFlag: null,
        tournamentsPlayed: 10,
        points: "504.00"
      },
      {
        playerId: 800310288,
        playerFamilyName: "SIEDLISKA",
        playerGivenName: "Natalia",
        playerNationalityCode: "GER",
        playerNationality: "Germany",
        profileLink: "/en/players/biography/800310288/GER/Natalia-SIEDLISKA/",
        birthYear: 1995,
        rankMovement: 0,
        rank: 35,
        rankEqualFlag: null,
        tournamentsPlayed: 14,
        points: "504.00"
      },
      {
        playerId: 800289895,
        playerFamilyName: "KIMMELMANN",
        playerGivenName: "Julia",
        playerNationalityCode: "GER",
        playerNationality: "Germany",
        profileLink: "/en/players/biography/800289895/GER/Julia-KIMMELMANN/",
        birthYear: 1993,
        rankMovement: 0,
        rank: 86,
        rankEqualFlag: "=",
        tournamentsPlayed: 8,
        points: "362.00"
      },
      {
        playerId: 800329486,
        playerFamilyName: "MORDERGER",
        playerGivenName: "Yana",
        playerNationalityCode: "GER",
        playerNationality: "Germany",
        profileLink: "/en/players/biography/800329486/GER/Yana-MORDERGER/",
        birthYear: 1997,
        rankMovement: 0,
        rank: 109,
        rankEqualFlag: null,
        tournamentsPlayed: 10,
        points: "330.00"
      }
    ],
    totalItems: 53
  },
  Id: 26931,
  Exception: null,
  Status: 5,
  IsCanceled: false,
  IsCompleted: true,
  CreationOptions: 0,
  AsyncState: null,
  IsFaulted: false
};

export const nationDataResponse = [
  { name: "American Samoa", code: "ASA", type: "nation" },
  { name: "Cameroon", code: "CMR", type: "nation" },
  { name: "North/Central America & Caribbean", code: "NCC", type: "zone" },
  { name: "South America", code: "SAM", type: "zone" }
];

export default {
  headToHeadBaseUrl: "/en/head-to-head/",
  rankDate: "06 January 2020",
  items: [
    {
      playerId: 800329736,
      playerFamilyName: "SIMION",
      playerGivenName: "Oana Georgeta",
      playerNationalityCode: "ROU",
      playerNationality: "Romania",
      profileLink: "/en/players/oana-georgeta-simion/800329736/rou/",
      birthYear: 1996,
      rankMovement: 0,
      rank: 1,
      rankEqualFlag: null,
      tournamentsPlayed: 14,
      points: 666.0,
      profileImage:
        "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137989e56609489039fe08.jpg?crop=0.34538379902305361,0.31185305139109115,0.32646598532782661,0.29415532093099628&cropmode=percentage&width=54&height=72&rnd=132221040940000000"
    },
    {
      playerId: 800367920,
      playerFamilyName: "KULIKOVA",
      playerGivenName: "Anastasia",
      playerNationalityCode: "FIN",
      playerNationality: "Finland",
      profileLink: "/en/players/anastasia-kulikova/800367920/fin/",
      birthYear: 2000,
      rankMovement: 0,
      rank: 2,
      rankEqualFlag: null,
      tournamentsPlayed: 21,
      points: 636.0,
      profileImage:
        "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
    },
    {
      playerId: 800366604,
      playerFamilyName: "MENDEZ",
      playerGivenName: "Seone",
      playerNationalityCode: "AUS",
      playerNationality: "Australia",
      profileLink: "/en/players/seone-mendez/800366604/aus/",
      birthYear: 1999,
      rankMovement: 0,
      rank: 3,
      rankEqualFlag: null,
      tournamentsPlayed: 11,
      points: 615.0,
      profileImage:
        "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cf240b48847dfe3e.jpg?crop=0.50423313281101367,0.061160353036376312,0.32664519531448488,0.60010538399292412&cropmode=percentage&width=54&height=72&rnd=132197953650000000"
    },
    {
      playerId: 800426616,
      playerFamilyName: "PEDRETTI",
      playerGivenName: "Thaisa Grana",
      playerNationalityCode: "BRA",
      playerNationality: "Brazil",
      profileLink: "/en/players/thaisa-grana-pedretti/800426616/bra/",
      birthYear: 1999,
      rankMovement: 0,
      rank: 4,
      rankEqualFlag: null,
      tournamentsPlayed: 12,
      points: 598.0,
      profileImage:
        "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137ab7e5240b769437.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132132047200000000"
    },
    {
      playerId: 800433162,
      playerFamilyName: "ZAKHAROVA",
      playerGivenName: "Anastasia",
      playerNationalityCode: "RUS",
      playerNationality: "Russia",
      profileLink: "/en/players/anastasia-zakharova/800433162/rus/",
      birthYear: 2002,
      rankMovement: 0,
      rank: 5,
      rankEqualFlag: null,
      tournamentsPlayed: 10,
      points: 570.0,
      profileImage:
        "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cf240b48847aff18.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132197934730000000"
    },
    {
      playerId: 800342757,
      playerFamilyName: "TURATI",
      playerGivenName: "Anna",
      playerNationalityCode: "ITA",
      playerNationality: "Italy",
      profileLink: "/en/players/anna-turati/800342757/ita/",
      birthYear: 1997,
      rankMovement: 0,
      rank: 6,
      rankEqualFlag: null,
      tournamentsPlayed: 9,
      points: 527.0,
      profileImage:
        "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cf240b48847bfe18.jpg?crop=0.37253694199846404,0.18651061944839512,0.42007135833228793,0.39384048679271588&cropmode=percentage&width=54&height=72&rnd=132197953150000000"
    },
    {
      playerId: 800307999,
      playerFamilyName: "BROULEAU",
      playerGivenName: "Lou",
      playerNationalityCode: "FRA",
      playerNationality: "France",
      profileLink: "/en/players/lou-brouleau/800307999/fra/",
      birthYear: 1995,
      rankMovement: 0,
      rank: 7,
      rankEqualFlag: null,
      tournamentsPlayed: 10,
      points: 514.0,
      profileImage:
        "/remote.axd/media.itftennis.com/asset-bank/servlet/display?file=22137999cf240b48be39fe3e.jpg?crop=0.296289712080472,0.010854977633493657,0.30371917661089076,0.59836582756073475&cropmode=percentage&width=54&height=72&rnd=132197951990000000"
    },
    {
      playerId: 800336305,
      playerFamilyName: "IVANOVA",
      playerGivenName: "Dasha",
      playerNationalityCode: "USA",
      playerNationality: "USA",
      profileLink: "/en/players/dasha-ivanova/800336305/usa/",
      birthYear: 1996,
      rankMovement: 0,
      rank: 8,
      rankEqualFlag: null,
      tournamentsPlayed: 15,
      points: 503.0,
      profileImage:
        "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
    },
    {
      playerId: 800292348,
      playerFamilyName: "ZACARIAS",
      playerGivenName: "Marcela",
      playerNationalityCode: "MEX",
      playerNationality: "Mexico",
      profileLink: "/en/players/marcela-zacarias/800292348/mex/",
      birthYear: 1994,
      rankMovement: 0,
      rank: 9,
      rankEqualFlag: null,
      tournamentsPlayed: 5,
      points: 500.0,
      profileImage:
        "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
    },
    {
      playerId: 800395417,
      playerFamilyName: "ASTAKHOVA",
      playerGivenName: "Darya",
      playerNationalityCode: "RUS",
      playerNationality: "Russia",
      profileLink: "/en/players/darya-astakhova/800395417/rus/",
      birthYear: 2002,
      rankMovement: 0,
      rank: 10,
      rankEqualFlag: null,
      tournamentsPlayed: 13,
      points: 482.0,
      profileImage:
        "/media/1489/itf-uk-profile-placeholder-female.jpg?anchor=center&mode=crop&width=54&height=72&rnd=132174204480000000"
    }
  ],
  totalItems: 2021
};

export const serniorsFilters = [
  {
    subFilter: [
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "35+",
        valueCode: "V35"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "40+",
        valueCode: "V40"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "45+",
        valueCode: "V45"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "50+",
        valueCode: "V50"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "55+",
        valueCode: "V55"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "60+",
        valueCode: "V60"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "65+",
        valueCode: "V65"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "70+",
        valueCode: "V70"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "75+",
        valueCode: "V75"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "80+",
        valueCode: "V80"
      },
      {
        subFilter: [
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: [
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Singles",
                valueCode: "S"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Doubles",
                valueCode: "D"
              },
              {
                subFilter: null,
                filterName: "Match Type",
                dataName: "matchTypeCode",
                valueDesc: "Mixed Doubles",
                valueCode: "MX"
              }
            ],
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "85+",
        valueCode: "V85"
      }
    ],
    filterName: "Rank Type",
    dataName: "seniorRankingType",
    valueDesc: "ITF Seniors Rankings",
    valueCode: "ITF"
  },
  {
    subFilter: [
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "35+",
        valueCode: "V35"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "40+",
        valueCode: "V40"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "45+",
        valueCode: "V45"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "50+",
        valueCode: "V50"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "55+",
        valueCode: "V55"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "60+",
        valueCode: "V60"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "65+",
        valueCode: "V65"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "70+",
        valueCode: "V70"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "75+",
        valueCode: "V75"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "80+",
        valueCode: "V80"
      },
      {
        subFilter: [
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Men",
            valueCode: "M"
          },
          {
            subFilter: null,
            filterName: "Player Type",
            dataName: "playerTypeCode",
            valueDesc: "Women",
            valueCode: "W"
          }
        ],
        filterName: "Age Category",
        dataName: "ageCategoryCode",
        valueDesc: "85+",
        valueCode: "V85"
      }
    ],
    filterName: "Rank Type",
    dataName: "seniorRankingType",
    valueDesc: "World Team Rankings",
    valueCode: "WORLD"
  }
];

export const stripProps = (filters) => filters.map(filter => ({
  label: filter.valueDesc,
  value: filter.valueCode,
  filterName: filter.filterName,
  selected: false
}))

export const regions = [{"subFilter":null,"filterName":"Region","dataName":"zoneCode","valueDesc":"Africa","valueCode":"AFR"},{"subFilter":null,"filterName":"Region","dataName":"zoneCode","valueDesc":"Asia","valueCode":"ASI"},{"subFilter":null,"filterName":"Region","dataName":"zoneCode","valueDesc":"Central America & Caribbean","valueCode":"CAC"},{"subFilter":null,"filterName":"Region","dataName":"zoneCode","valueDesc":"Europe","valueCode":"EUR"},{"subFilter":null,"filterName":"Region","dataName":"zoneCode","valueDesc":"North America","valueCode":"NA"},{"subFilter":null,"filterName":"Region","dataName":"zoneCode","valueDesc":"Oceania","valueCode":"OCE"},{"subFilter":null,"filterName":"Region","dataName":"zoneCode","valueDesc":"South America","valueCode":"SAM"}];

export var nations = [{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Afghanistan","valueCode":"AFG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Albania","valueCode":"ALB"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Algeria","valueCode":"ALG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"American Samoa","valueCode":"ASA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Andorra","valueCode":"AND"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Angola","valueCode":"ANG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Anguilla","valueCode":"AIA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Antigua & Barbuda","valueCode":"ANT"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Argentina","valueCode":"ARG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Armenia","valueCode":"ARM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Aruba","valueCode":"ARU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Australia","valueCode":"AUS"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Austria","valueCode":"AUT"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Azerbaijan","valueCode":"AZE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bahamas","valueCode":"BAH"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bahrain","valueCode":"BRN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bangladesh","valueCode":"BAN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Barbados","valueCode":"BAR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Belarus","valueCode":"BLR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Belgium","valueCode":"BEL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Belize","valueCode":"BIZ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Benin","valueCode":"BEN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bermuda","valueCode":"BER"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bhutan","valueCode":"BHU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bolivia","valueCode":"BOL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bonaire","valueCode":"BES"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bosnia and Herzegovina","valueCode":"BIH"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Botswana","valueCode":"BOT"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Brazil","valueCode":"BRA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"British Virgin Islands","valueCode":"IVB"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Brunei","valueCode":"BRU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Bulgaria","valueCode":"BUL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Burkina Faso","valueCode":"BUR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Burundi","valueCode":"BDI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cambodia","valueCode":"CAM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cameroon","valueCode":"CMR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Canada","valueCode":"CAN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cape Verde","valueCode":"CPV"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cayman Islands","valueCode":"CAY"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Central African Republic","valueCode":"CAF"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Chad","valueCode":"CHA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Chile","valueCode":"CHI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"China, P.R.","valueCode":"CHN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Chinese Taipei","valueCode":"TPE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Colombia","valueCode":"COL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Comoros","valueCode":"COM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Congo","valueCode":"CGO"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Congo, Dem. Rep.","valueCode":"COD"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cook Islands","valueCode":"COK"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Costa Rica","valueCode":"CRC"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cote D'Ivoire","valueCode":"CIV"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Croatia","valueCode":"CRO"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cuba","valueCode":"CUB"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Curacao","valueCode":"CUW"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Cyprus","valueCode":"CYP"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Czech Republic","valueCode":"CZE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Denmark","valueCode":"DEN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Djibouti","valueCode":"DJI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Dominica","valueCode":"DMA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Dominican Republic","valueCode":"DOM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Ecuador","valueCode":"ECU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Egypt","valueCode":"EGY"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"El Salvador","valueCode":"ESA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Equatorial Guinea","valueCode":"GEQ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Eritrea","valueCode":"ERI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Estonia","valueCode":"EST"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"eSwatini","valueCode":"SWZ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Ethiopia","valueCode":"ETH"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Fiji","valueCode":"FIJ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Finland","valueCode":"FIN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"France","valueCode":"FRA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"French Guiana","valueCode":"FGU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"French Polynesia","valueCode":"PYF"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Gabon","valueCode":"GAB"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Gambia","valueCode":"GAM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Georgia","valueCode":"GEO"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Germany","valueCode":"GER"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Ghana","valueCode":"GHA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Gibraltar","valueCode":"GIB"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Gilbert Islands","valueCode":"GIL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Great Britain","valueCode":"GBR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Greece","valueCode":"GRE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Greenland","valueCode":"GLD"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Grenada","valueCode":"GRN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Guadeloupe","valueCode":"GUD"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Guam","valueCode":"GUM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Guatemala","valueCode":"GUA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Guinea-Bissau","valueCode":"GBS"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Guinea-Conakry","valueCode":"GUI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Guyana","valueCode":"GUY"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Haiti","valueCode":"HAI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Honduras","valueCode":"HON"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Hong Kong, China","valueCode":"HKG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Hungary","valueCode":"HUN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Iceland","valueCode":"ISL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"India","valueCode":"IND"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Indonesia","valueCode":"INA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"International Tennis Federation","valueCode":"ITF"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Iran","valueCode":"IRI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Iraq","valueCode":"IRQ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Ireland","valueCode":"IRL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Israel","valueCode":"ISR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Italy","valueCode":"ITA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Jamaica","valueCode":"JAM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Japan","valueCode":"JPN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Jordan","valueCode":"JOR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Kazakhstan","valueCode":"KAZ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Kenya","valueCode":"KEN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Kiribati","valueCode":"KIR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Korea, D.P.R.","valueCode":"PRK"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Korea, Rep.","valueCode":"KOR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Kosovo","valueCode":"KOS"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Kuwait","valueCode":"KUW"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Kyrgyzstan","valueCode":"KGZ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Laos","valueCode":"LAO"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Latvia","valueCode":"LAT"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Lebanon","valueCode":"LBN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Lesotho","valueCode":"LES"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Liberia","valueCode":"LBR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Libya","valueCode":"LBA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Liechtenstein","valueCode":"LIE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Lithuania","valueCode":"LTU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Luxembourg","valueCode":"LUX"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Macau","valueCode":"MAC"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Madagascar","valueCode":"MAD"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Malawi","valueCode":"MAW"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Malaysia","valueCode":"MAS"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Maldives","valueCode":"MDV"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Mali","valueCode":"MLI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Malta","valueCode":"MLT"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Marshall Islands","valueCode":"MHL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Martinique","valueCode":"MRN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Mauritania","valueCode":"MTN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Mauritius","valueCode":"MRI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Mexico","valueCode":"MEX"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Micronesia, Fed. States","valueCode":"FSM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Moldova","valueCode":"MDA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Monaco","valueCode":"MON"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Mongolia","valueCode":"MGL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Montenegro","valueCode":"MNE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Montserrat","valueCode":"MNT"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Morocco","valueCode":"MAR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Mozambique","valueCode":"MOZ"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Myanmar","valueCode":"MYA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Namibia","valueCode":"NAM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Nauru","valueCode":"NRU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Nepal","valueCode":"NEP"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Netherlands","valueCode":"NED"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"New Caledonia","valueCode":"CAL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"New Zealand","valueCode":"NZL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Nicaragua","valueCode":"NCA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Niger","valueCode":"NIG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Nigeria","valueCode":"NGR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Norfolk Island","valueCode":"NFK"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"North Macedonia","valueCode":"MKD"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Northern Mariana Islands","valueCode":"NMI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Norway","valueCode":"NOR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Oman","valueCode":"OMA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Pacific Oceania","valueCode":"POC"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Pakistan","valueCode":"PAK"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Palau","valueCode":"PLW"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Palestine","valueCode":"PLE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Panama","valueCode":"PAN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Papua New Guinea","valueCode":"PNG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Paraguay","valueCode":"PAR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Peru","valueCode":"PER"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Philippines","valueCode":"PHI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Poland","valueCode":"POL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Portugal","valueCode":"POR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Puerto Rico","valueCode":"PUR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Qatar","valueCode":"QAT"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Reunion","valueCode":"REU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Romania","valueCode":"ROU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Russia","valueCode":"RUS"},
  {"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Rwanda","valueCode":"RWA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Samoa","valueCode":"SAM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"San Marino","valueCode":"SMR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Sao Tome & Principe","valueCode":"STP"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Saudi Arabia","valueCode":"KSA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Senegal","valueCode":"SEN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Serbia","valueCode":"SRB"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Seychelles","valueCode":"SEY"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Sierra Leone","valueCode":"SLE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Singapore","valueCode":"SGP"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Slovakia","valueCode":"SVK"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Slovenia","valueCode":"SLO"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Solomon Islands","valueCode":"SOL"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Somalia","valueCode":"SOM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"South Africa","valueCode":"RSA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Spain","valueCode":"ESP"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Sri Lanka","valueCode":"SRI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"St. Kitts & Nevis","valueCode":"SKN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"St. Lucia","valueCode":"LCA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"St. Vincent & the Grenadines","valueCode":"VIN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Sudan","valueCode":"SUD"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Surinam","valueCode":"SUR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Sweden","valueCode":"SWE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Switzerland","valueCode":"SUI"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Syria","valueCode":"SYR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Tahiti","valueCode":"TAH"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Tajikistan","valueCode":"TJK"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Tanzania","valueCode":"TAN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Thailand","valueCode":"THA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Timor-Leste","valueCode":"TLS"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Togo","valueCode":"TOG"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Tonga","valueCode":"TGA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Trinidad & Tobago","valueCode":"TTO"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Tunisia","valueCode":"TUN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Turkey","valueCode":"TUR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Turkmenistan","valueCode":"TKM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Turks & Caicos Islands","valueCode":"TKS"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Tuvalu","valueCode":"TUV"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Uganda","valueCode":"UGA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Ukraine","valueCode":"UKR"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"United Arab Emirates","valueCode":"UAE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Uruguay","valueCode":"URU"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"US Virgin Islands","valueCode":"ISV"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"USA","valueCode":"USA"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Uzbekistan","valueCode":"UZB"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Vanuatu","valueCode":"VAN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Venezuela","valueCode":"VEN"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Vietnam","valueCode":"VIE"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Yemen","valueCode":"YEM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Zambia","valueCode":"ZAM"},{"subFilter":null,"filterName":"Nation","dataName":"nationCode","valueDesc":"Zimbabwe","valueCode":"ZIM"}];